/** Copyright 2025 Midas Healthcare Solutions - All Rights Reserved **/
import { DragDropModule } from '@angular/cdk/drag-drop';
import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatDialogRef } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { GeneralSettings, SettingsGroups } from '@midas/shared/common';
import { UserActions } from '@midas/shared/data-access';
import { TranslocoModule } from '@ngneat/transloco';
import { Store } from '@ngrx/store';

@Component({
  selector: 'midas-video-overlay-help-dialog',
  templateUrl: './video-overlay-help-dialog.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, MatCheckboxModule, DragDropModule, TranslocoModule],
})
export class VideoOverlayHelpDialogComponent {
  constructor(
    private store: Store,
    private dialogRef: MatDialogRef<VideoOverlayHelpDialogComponent>,
  ) {}

  doNotShowAgain = false;

  doNotShowAgainChanged() {
    this.doNotShowAgain = !this.doNotShowAgain;
  }

  continue() {
    if (this.doNotShowAgain) {
      this.store.dispatch(
        UserActions.updateUserAlibiSettings({
          settingsGroup: SettingsGroups.GeneralSettings,
          settingsJson: JSON.stringify({
            [GeneralSettings.HideVideoOverlayHelp]: true,
          }),
        }),
      );
    }

    this.dialogRef.close();
  }
}
